export const mairimedTags = [
  "psiquiatria",
  "medicina",
  "neuropsiquiatria",
  "transtorno bipolar",
  "emtr",
];
